var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper_group_dashboard"},[_c('div',{staticClass:"group_dashboard"},[_c('div',{staticClass:"configured_plans_main"},[_vm._m(0),_c('div',[_c('add-plan')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configured_plans_detail"},[_c('h2',[_vm._v("Configured Plans")])])
}]

export { render, staticRenderFns }